import { ChangeDetectionStrategy, Component, inject, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewComponent, TreeNodeEvent } from '@libs/front/components/tree-view/tree-view.component';
import { NavLeftService } from 'src/app/services/nav-left.service';

@Component({
  selector:        'app-nav-left',
  standalone:      true,
  imports:         [CommonModule, TreeViewComponent],
  templateUrl:     './nav-left.component.html',
  styleUrls:       ['./nav-left.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavLeftComponent {

  protected navLeft = inject(NavLeftService);

  // Onglet actif — 'filter' par défaut, 'settings' si settingsTemplate fourni
  protected activeTab = signal<'filter' | 'settings'>('filter');

  // Affiche les onglets uniquement si settingsTemplate est fourni
  protected hasSettings = computed(
    () => !!this.navLeft.config().settingsTemplate
  );

  handleNodeClick(event: TreeNodeEvent): void {
    this.navLeft.config().onNodeClick?.(event);
    this.navLeft.hideMobileNav();
  }
}